import type {AppProps} from 'next/app';
import {useAuth} from '@local/hooks/useAuth';

export const Page = ({Component, pageProps}: {Component: AppProps['Component']; pageProps: AppProps['pageProps']}) => {
  const initialized = useAuth();
  if (initialized) {
    return <Component {...pageProps} />;
  } else {
    return null;
  }
};
